import { render, staticRenderFns } from "./ArchivedMissions.vue?vue&type=template&id=5445103a&"
import script from "./ArchivedMissions.vue?vue&type=script&lang=js&"
export * from "./ArchivedMissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports